import { UserModalLayout } from '@features/components/UserModalLayout';
import { PropsWithChildren } from 'react';
import { EmployeeModalContent } from './EmployeeModalContent';
import { Uuid } from '@/api/types';

export const EmployeeModal = ({ children, employeeId }: { employeeId: Uuid } & PropsWithChildren) => {
  return (
    <UserModalLayout trigger={children}>
      <EmployeeModalContent employeeId={employeeId} />
    </UserModalLayout>
  );
};
